<h2 mat-dialog-title>{{'media.deleteDialog.title' | translate}}</h2>

<mat-dialog-content>
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100">
      <div class="p-2 pb-2 d-flex flex-column justify-content-center align-items-center">

        <span class="p-1 fw-bolder text-wrap text-break">{{'media.deleteDialog.message' | translate}}</span>

        <span class="p-1 fst-italic text-wrap text-break">{{data.fileName}}</span>

        @if (data.usedInTemplates?.length > 0) {
          <div class="mt-2 w-100">
            <span class="p-1">{{'media.deleteDialog.usedIn' | translate}}</span>
            <ul class="mt-1">
              @for (name of data.usedInTemplates; track name) {
                <li>{{name}}</li>
              }
            </ul>
          </div>
        }

      </div>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" [mat-dialog-close]="false">
    {{'cancel' | translate}}
  </button>
  <button mat-button class="orange-button" style="color:var(--warmOrange);" [mat-dialog-close]="true">
    {{'confirm' | translate}}
  </button>
</mat-dialog-actions>
